import { ChangeEvent, ReactNode } from "react";
import { IconCircleX } from "@tabler/icons-react";

import { createChangeEvent } from "../../utils/form";

interface TextAreaProps {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  icon?: ReactNode;
  value?: string;
  placeholder?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  error?: string;
  rows?: number;
}

const baseStyle = `
  bg-bg-components-base border px-3 py-2.5 rounded-lg placeholder:text-text-subtle placeholder:disabled:text-text-disabled
  hover:bg-bg-components-hover 
  disabled:bg-bg-disabled disabled:border-border-disabled disabled:cursor-not-allowed disabled:outline-0 disabled:outline-offset-0
`;

const outlineStyle = `
  border-border-strong
  focus:bg-bg-components-hover focus:outline-focus focus:outline-offset-1
  active:border-border-interactive-base active:outline-input-interactive active:outline-offset-0
`;

const errorStyle = `
  border-border-danger-base outline-input-danger
`;

const TextArea = ({
  label, required = false, disabled = false, name, icon, value, placeholder, onChange, error, rows = 4,
}: TextAreaProps) => (
  <div className="flex flex-col gap-1 typography-medium-base text-text-base">
    <label className="flex gap-1" htmlFor={name}>
      <span>{label}</span>
      {required && <span className="text-text-danger">*</span>}
      {icon && <span className="text-icon-bg-subtle">{icon}</span>}
    </label>
    <textarea
      id={name}
      className={`${baseStyle} ${error ? errorStyle : outlineStyle}`}
      rows={rows}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        onChange(createChangeEvent(name, e.target.value), e.target.value);
      }}
    />
    {error && (
      <div className="flex gap-1">
        <IconCircleX className="text-icon-danger" />
        <span className="text-text-danger">{error}</span>
      </div>
    )}
  </div>
);

export default TextArea;
